class KsInstagramGallery extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.waitForSwiper()
      .then(() => this.init())
      .catch((error) => console.error(error));
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  waitForSwiper() {
    return new Promise((resolve, reject) => {
      if (typeof window.Swiper !== 'undefined') {
        resolve();
        return;
      }

      const interval = setInterval(() => {
        if (typeof window.Swiper !== 'undefined') {
          clearInterval(interval);
          resolve();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(interval);
        if (typeof window.Swiper === 'undefined') {
          reject(new Error('Swiper library did not load in time.'));
        }
      }, 5000);
    });
  }

  init() {
    const autoplayOptions =
      this.dataset.sliderAutoplay === '0'
        ? false
        : {
            delay: Number(this.dataset.sliderAutoplay) * 1000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          };

    const swiperOptions = {
      speed: Number(this.dataset.sliderSpeed) || 800,
      centeredSlides: true,
      loop: true,
      autoplay: autoplayOptions,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.4,
          spaceBetween: Number(this.dataset.swiperSpacingMobile) || 10,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: Number(this.dataset.swiperSpacingMobile) || 10,
        },
        900: {
          slidesPerView: 3,
          spaceBetween: Number(this.dataset.swiperSpacingMobile) || 10,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: Number(this.dataset.swiperSpacingDesktop) || 20,
        },
        1500: {
          slidesPerView: 5,
          spaceBetween: Number(this.dataset.swiperSpacingDesktop) || 20,
        },
        1800: {
          slidesPerView: 6,
          spaceBetween: Number(this.dataset.swiperSpacingDesktop) || 20,
        },
      },
      on: {
        init: () => {
          this.classList.add('is-ready');
        },
        imagesReady: () => {
          this.classList.add('is-ready');
        },
      },
    };

    this.swiperInstance = new window.Swiper(this, swiperOptions);
  }
}

if (!customElements.get('ks-instagram-gallery')) {
  customElements.define('ks-instagram-gallery', KsInstagramGallery);
}